import { render } from "./Dash_Board.vue?vue&type=template&id=b34fbe68&scoped=true"
import script from "./Dash_Board.vue?vue&type=script&lang=js"
export * from "./Dash_Board.vue?vue&type=script&lang=js"

import "./Dash_Board.vue?vue&type=style&index=0&id=b34fbe68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34fbe68"]])

export default __exports__